import ResearchData from "./ResearchData";

export default abstract class ResearchDataRepository {
    abstract insert(data: ResearchData): void;
    abstract fetchAllBySessionId (sessionId: string): Promise<ResearchData[]>
}